import { AccountWithMappedBalanceAndChargesData, GroupedAccountWithMappedBalanceAndChargesData } from '../../../mappers/accounts/balanceAndCharges/index';
import { createDataFetchSlice } from '../../../utils/dataFetch';


export const accountsWithBalanceAndChargesSlice = createDataFetchSlice<
    GroupedAccountWithMappedBalanceAndChargesData[]
>({ name: 'balanceAndCharges' });
